import React from 'react';
import { css } from '@emotion/react';

import { config } from '@config/pendo.config.json';
import LoadingPlaceholder from 'shared/components/loading-placeholder';
import { largeSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  flex: 1;
  padding: ${tripleSpacing}px ${largeSpacing}px ${largeSpacing}px ${largeSpacing}px;
`;

const SubmissionRightColumnSkeleton: React.FC = () => (
  <div css={styles} data-qa={config.pendo.submissionView.rightColumn.loading}>
    <LoadingPlaceholder />
  </div>
);

export default SubmissionRightColumnSkeleton;
